/* eslint-disable */
import { createBrowserHistory } from "history"
export let history = createBrowserHistory();